import React, { useState } from 'react';
import classNames from 'classnames';

import './PolygonSearchSection.css';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';

const PolygonSearchSection = ({ searchPolygonsText, searchPolygons, searchPolygonsBorderColor }) => {
  const [isInputFocused, setIsInputFocused] = useState(false);

  const onFocusHandler = () => {
    setIsInputFocused(true);
    searchPolygonsBorderColor('#5da4db');
  };

  const onBlurHandler = () => {
    setIsInputFocused(false);
    searchPolygonsBorderColor('#f2f2f2');
    searchPolygons('');
  };

  return (
    <div className="PolygonSearchSection">
      { 
        !isInputFocused && (
          <div className='PolygonSearchSection_Icon'>
            <SvgAF
              img={IconLoader.icon_search}
            />
          </div>
        )
      }

      <input
        className={classNames({
          'PolygonSearchSection_Input': true,
          'PolygonSearchSection_Input_Focused': isInputFocused
        })}
        placeholder={!isInputFocused ? 'Search Polygon' : ''}
        value={searchPolygonsText}
        onFocus={onFocusHandler}
        onBlur={onBlurHandler}
        onChange={(e) => searchPolygons(e.target.value)}
      />

      {
        searchPolygonsText.trim() && (
          <div className='PolygonSearchSection_Clear_Icon' onClick={() => searchPolygons('')}>
            <SvgAF 
              img={IconLoader.icon_close_mid}
              hover={IconLoader.icon_close_mid_hover}
            />
          </div>
        )
      }
    </div>
  )
};

export default PolygonSearchSection;